import React, { useRef, useEffect, useCallback, useState} from 'react';
import {MIDI_FX} from "constants/effect-types.js";
import {
    initializeEffect,
    effectOptions,
    initializeMidiEffect,
    midiEffectOptions,
} from 'components/effects/constants.js';
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import AudioFXMenu from "components/pulled/AudioFXMenu.js";
import {setDrawingPadEdge} from 'actions/index.js';
import {connect} from 'react-redux';

const EffectOutput = ({
    isControl,
    containerRef,
    pad,
    setDrawingPadEdge,
    fx,
    rack,
    id=fx.id,
    coords,
    nodeRef,
    outputNumber,
}) => { 
    let _id = 'effect-output-' + id;
    if (outputNumber !== undefined) {
        _id = 'effect-output-' + outputNumber + '-' + id;
    }
    let ref = useRef(undefined);
    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref});
    const dropdownPosRef = useRef({
        x:0, y:0});

    useEffect(() => {
        if (coords && nodeRef && nodeRef.current) {
            let {x,y} = coords;
            x += nodeRef.current.offsetWidth + 20;
            dropdownPosRef.current.x = x;
            dropdownPosRef.current.y = y;
        }
    }, [coords]);

    const onMouseDown = useCallback((e) => {
        let rect = containerRef.current.getBoundingClientRect();
        let x = e.clientX;
        let y = e.clientY;

        let {edgesPadding} = pad.state.spatial;
        let coords = {
            effect: isControl ? fx.inputNode : fx,
            outputNumber,
            rack: rack,
            x1: x,
            y1: y,
            x2: x,
            y2: y
        };
        e.stopPropagation();

        setDrawingPadEdge(pad.subSequence.id, coords);
    }, []);
    let isMidi = fx.getEffectType && fx.getEffectType() === MIDI_FX;
    let style = {
    };
    if (fx.numberOfOutputs > 1) {
        style.top = (30 + outputNumber*20)+"%";
    }
    return (<div
              ref={ref}
              style={style}
              onContextMenu={onContextMenu}
              id={_id}
              onMouseDown={onMouseDown}
              className="effect-output">
              {!isControl &&
               <AudioFXMenu
                 isMidi={isMidi}
                 setDropdownPos={setDropdownPos}
                 outputNumber={outputNumber}
                 dropdownPosRef={dropdownPosRef}
                 effectOptions={isMidi ? midiEffectOptions : effectOptions}
                 initializeEffect={isMidi ? initializeMidiEffect : initializeEffect}
                 dropdownPos={dropdownPos}
                 effect={fx}
                 node={pad}/>}
            </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setDrawingPadEdge: (x,y) => dispatch(setDrawingPadEdge(x,y))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectOutput);
